var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"content-container",attrs:{"light":""}},[_c('v-card-text',{staticClass:"scrollable"},[(_vm.pageData !== undefined)?_c('WebPageLegacy',{attrs:{"pageData":_vm.pageData,"fill-width":"","showTitle":false,"showHeader":false}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }